"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_EPOINTAGE_COMMENT = void 0;
const client_1 = require("@apollo/client");
exports.UPDATE_EPOINTAGE_COMMENT = client_1.gql `
  mutation updateEPointageComment(
    $siteId: String!
    $etaId: String!
    $claId: String!
    $scheduleId: Int!
    $date: String!
    $updateUser: Int!
    $updateDate: String!
    $comment: String
  ) {
    updateEPointageComment(
      siteId: $siteId
      etaId: $etaId
      claId: $claId
      scheduleId: $scheduleId
      date: $date
      updateUser: $updateUser
      updateDate: $updateDate
      comment: $comment
    ) {
      scheduleId
      date
      updateUser
      updateDate
      comment
    }
  }
`;
